


export const QuestionBank = [
    {
        category: "نص",
        questions: [
            {
                type: "SINGLE_ROW_TEXT",
                questionCode: "Q",
                name: "نص صف واحد",
                icon: "pi-pencil",
                value: '',
                meta: {
                    fields: [
                        { label: "السؤال", valueLabel: "اجب هنا", value: '' , isNumeric: false, isNumericLimit: 10 }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                }
            },
            {
                type: "EMAIL_ADDRESS",
                questionCode: "Q",
                name: "عنوان البريد الإلكتروني",
                icon: "pi-envelope",
                value: '',
                meta: {
                    fields: [
                        { label: "عنوان البريد الإلكتروني", valueLabel: "عنوان البريد الإلكتروني", value: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "COMMENT_BOX",
                questionCode: "Q",
                name: "صندوق التعليقات",
                icon: "pi-comment",
                meta: {
                    fields: [
                        { label: "التعليقات/الاقتراحات:", valueLabel: "اكتب هنا", value: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "CONTACT_INFO",
                questionCode: "Q",
                name: "معلومات التواصل",
                questionText: "معلومات التواصل",
                icon: "pi-users",
                meta: {
                    fields: [
                        { label: "الاسم الأول", value: '' },
                        { label: "اسم العائلة", value: '' },
                        { label: "رقم الهاتف", value: '' },
                        { label: "عنوان البريد الإلكتروني", value: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
        ]
    },
    {
        category: "متعدد الخيارات",
        questions: [
            {
                type: "SELECT_ONE",
                questionCode: "Q",
                name: "حدد واحدًا",
                icon: "pi-circle",
                questionText: "اختر الإجابة الصحيحة",

                meta: {
                    value: '',
                    fields: [
                        { label: "خيار 1" },
                        { label: "خيار 2" }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                    correct:" "
                }
            },
            {
                type: "SELECT_MANY",
                questionCode: "Q",
                name: "حدد العديد",
                icon: "pi-check-circle",
                questionText: "اختر الإجابة الصحيحة، يمكنك اختيار أكثر من خيار",
                meta: {
                    value: [],
                    correct: [],
                    fields: [
                        { label: "خيار 1", value: '', },
                        { label: "خيار 2", value: '', }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "DROPDOWN_MENU",
                questionCode: "Q",
                name: "القائمة المنسدلة",
                icon: "pi-chevron-circle-down",
                questionText: "اختر الإجابة الصحيحة",
                meta: {
                    value: '',
                    fields: [
                        { label: "خيار 1" },
                        { label: "خيار 2" }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                    correct:""
                }
            }
        ]
    },

    {
        category: "Image Chooser",
        questions: [
            {
                type: "SELECT_ONE_IMAGE",
                questionCode: "Q",
                name: "Select One",
                icon: "pi-image",
                questionText: "اختر صورة واحدة",
                meta: {
                    value: '',
                    fields: [
                        { label: "صورة 1", url: '' },
                        { label: "صورة 2", url: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                    correct:""
                }
            },
            {
                type: "SELECT_MANY_IMAGE",
                questionCode: "Q",
                name: "Select Many",
                icon: "pi-images",
                questionText: "اختر الإجابة الصحيحة، يمكنك اختيار أكثر من خيار",
                meta: {
                    value: [],
                    correct: [],
                    fields: [
                        { label: "صورة 1", url: '' },
                        { label: "صورة 2", url: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
        ]
    },

    {
        category: "Graphical Rating",
        questions: [
            {
                type: "STAR_RATING",
                questionCode: "Q",
                name: "Star Rating",
                icon: "pi-star",
                questionText: "كيف كانت تجربتك؟",
                meta: {
                    fields: [
                        { label: "خيار 1", value: '', correct: '' },
                        { label: "خيار 2", value: '', correct: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "SMILE_RATING",
                questionCode: "Q",
                name: "Smiley Rating",
                icon: "fa-smile-o",
                questionText: "ما مدى رضاك؟",
                meta: {
                    value: '',
                    fields: [
                        { label: 'مستاء جداً', image: '../../../../../assets/rating/s-5.svg' },
                        { label: 'مستاء', image: '../../../../../assets/rating/s-4.svg' },
                        { label: 'محايد', image: '../../../../../assets/rating/s-3.svg' },
                        { label: 'راضٍ', image: '../../../../../assets/rating/s-2.svg' },
                        { label: 'راضٍ جداً', image: '../../../../../assets/rating/s-1.svg' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                    correct:""
                }
            },
        ]
    },

    {
        category: "Basic Matrix",
        questions: [
            {
                type: "MULTI_POINT_SCALE",
                questionCode: "Q",
                name: "Multi-Point Scales",
                icon: "pi-check-circle",
                questionText: "ما مدى رضاك؟",
                meta: {
                    leftAnchor: 'الجزء العلوي',
                    rightAnchor: 'الجزء السفلي',
                    columns: ['عمود 1', 'عمود 2'],
                    fields: [
                        {
                            field: { label: "خيار 1", value: '', correct: '' },
                        },
                        {
                            field: { label: "خيار 2", value: '', correct: '' },
                        }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                }
            },
            {
                type: "MULTI_SELECT_SCALE",
                questionCode: "Q",
                name: "Multi-Select",
                icon: "pi-check-square",
                questionText: "كيف كانت تجربتك؟",
                meta: {
                    leftAnchor: 'الجزء العلوي',
                    rightAnchor: 'الجزء السفلي',
                    columns: ['عمود 1', 'عمود 2'],
                    fields: [
                        {
                            field: { label: "خيار 1" },
                            value: [],
                            correct: []
                        },
                        {
                            field: { label: "خيار 2" },
                            value: [],
                            correct: []
                        }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                }
            },
        ]
    },

    {
        category: "Ordering",
        questions: [
            {
                type: "RANK_ORDER",
                questionCode: "Q",
                name: "Rank Order",
                icon: "pi-sort-amount-up",
                questionText: "رتب الآتي",
                meta: {
                    options: [],
                    fields: [
                        { label: "خيار ١", value: '' },
                        { label: "خيار ٢", value: '' },
                        { label: "خيار ٣", value: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "DRAG_DROP",
                questionCode: "Q",
                name: "Drag and Drop",
                icon: "pi-arrow-right-arrow-left",
                questionText: "رتب الآتي",
                value: '',
                meta: {
                    topAnchor: 'الجزء العلوي',
                    bottomAnchor: 'الجزء السفلي',
                    fields: [
                        { label: "Skiing", value: '', order: 1, correct:'' },
                        { label: "Snowboarding", value: '', order: 2, correct:'' },
                        { label: "Biking", value: '', order: 3, correct:''}
                    ],
                    orderedFields: [
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
        ]
    },

    {
        category: "Misc",
        questions: [
            {
                type: "DATE_TIME",
                questionCode: "Q",
                name: "Date/Time",
                icon: "pi-calendar",
                questionText: "أدخل تاريخ ميلادك",
                meta: {
                    value: { day: '', month: '', year: '' },
                    correct: { day: '', month: '', year: '' },
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "CALENDAR",
                questionCode: "Q",
                name: "Calendar",
                icon: "pi-calendar",
                questionText: "أدخل تاريخ ميلادك",
                meta: {
                    value: '',
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
            {
                type: "OU_TREE_DROPDOWN",
                questionCode: "Q",
                name: "اختر جهة",
                icon: "pi-sitemap",
                questionText: "اختر جهة",
                meta: {
                    value: '',
                    selectedOu: null,
                    description: '',
                    feedback: '',
                    ouTreeTags: ['Ministries/Entities', 'Organisational Units', 'Branches', 'Organisational Structure'],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10
                }
            },
        ]
    },

    {
        category: "Static Content",
        questions: [
            {
                type: "PRESENTATION_TEXT",
                questionCode: "Q",
                name: "Presentation Text",
                icon: "pi-tag",
                questionText: "إضافة نص",
                meta: {
                    condition: {
                        question: null,
                        option: null
                    },
                }
            },
            {
                type: "SECTION_HEADING",
                questionCode: "Q",
                name: "Section Heading",
                icon: "pi-tag",
                questionText: "إضافة نص",
                meta: {
                    condition: {
                        question: null,
                        option: null
                    },
                }
            },
            {
                type: "SECTION_SUB_HEADING",
                questionCode: "Q",
                name: "Section Sub-Heading",
                icon: "pi-tag",
                questionText: "إضافة نص",
                meta: {
                    condition: {
                        question: null,
                        option: null
                    },
                }
            }
        ]
    },
    {
        category: "Thank You Messages",
        questions: [
            {
                type: "DYNAMIC_MESSAGE",
                questionCode: "Q",
                name: "Dynamic Message",
                icon: "pi-bell",
                questionText: "إضافة نص",
                meta: {
                    condition: {
                        question: null,
                        option: null
                    },
                }
            },
        ]
    },
    {
        category: "Impact Measurement",
        questions: [
            {
                type: "IMPACT_MEASUREMENT",
                questionCode: "Q",
                name: "Impact Measurement",
                icon: "pi-star",
                questionText: "كيف كانت تجربتك؟",
                meta: {
                    fields: [
                        { label: "خيار 1", value: '', correct: '' },
                        { label: "خيار 2", value: '', correct: '' }
                    ],
                    condition: {
                        question: null,
                        option: null
                    },
                    marks: 10,
                    correctAnswer: '',
                    empAnswer: '',
                    comment: '',
                }
            }
        ]
    }
]